import RadioButton from "components/RadioButton";
import { VscSend } from 'react-icons/vsc';
import "./style.css";

interface TableAntecipationProps {
  header: string[];
  data?: any[];
  selectedItems?: string[];
  onToggleItem?: (id: string) => void;
  onToggleAll?: (data: any[]) => void;
  selectAll?: boolean;
  navigate?: (rowIndex: number) => void;
}

const TableAntecipation: React.FC<TableAntecipationProps> = ({
  header,
  data,
  onToggleAll,
  onToggleItem,
  selectedItems = [],
  selectAll = false,
  navigate,
}) => {
  return (
    <>
      {selectAll && (
        <div
          style={{
            alignItems: "center",
            justifyContent: "flex-end",
            flexDirection: "row",
            display: "flex",
            gap: "10px",
            color: "#000",
            fontWeight: 600,
          }}
        >
          <RadioButton
            value="all"
            checked={selectedItems.length === data?.length && data?.length > 0}
            onChange={() => data && onToggleAll && onToggleAll(data)}
          />
          <span style={{ color: "#000" }}>SELECIONAR TUDO</span>
        </div>
      )}
      <table className="table">
        <thead className="table-header">
          {header?.map((item, index) => (
            <th key={index}>{item}</th>
          ))}
          {selectAll && <th></th>}
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.entries(row)
                .filter(([key]) => key !== "idCompra")
                .map(([key, value], cellIndex) => (
                  <td key={cellIndex}>{value}</td>
                ))}

              {selectAll && (
                <td>
                  <RadioButton
                    value={row.idCompra}
                    checked={selectedItems.includes(row.idCompra)}
                    onChange={() => onToggleItem && onToggleItem(row.idCompra)}
                  />
                </td>
              )}
              {navigate && (
                <td>
                {row.formaPagamento === "PIX" && row.status === 'A FATURAR' && (
                  <button onClick={() => navigate && navigate(rowIndex)}>
                    <VscSend size={20} color="#E71037"/>
                  </button>
                )}
              </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default TableAntecipation;
